import { PropsWithChildren, ReactNode, useState } from 'react';

import { Box, Button } from '@mui/material';

import { ReactComponent as ClipboardIcon } from 'assets/icons/ClipboardText.svg';
import { ReactComponent as CaretIcon } from 'assets/icons/Caret.svg';
import { SECOND_IN_MILLISECONDS } from 'constants/general';

type DataCellProps = PropsWithChildren<{ className?: string; wallet?: boolean }>;

const DataCell = ({ children, className, wallet = false }: DataCellProps) => {
  const [copied, setCopied] = useState(false);

  const getTextContent = (node: ReactNode): string => {
    if (typeof node === 'string' || typeof node === 'number') {
      return node.toString();
    }
    return '';
  };

  const shortWalletAddress = wallet ? getTextContent(children).replace(/^(.{4}).*(.{4})$/, '$1....$2') : null;

  const handleCopy = async () => {
    const textToCopy = getTextContent(children);
    if (textToCopy) {
      try {
        await navigator.clipboard.writeText(textToCopy);
        setCopied(true);
        setTimeout(() => setCopied(false), SECOND_IN_MILLISECONDS);
      } catch (error) {
        console.error('Failed to copy:', error);
      }
    }
  };

  return (
    <Box className={className} display='flex' alignItems='center' gap={2}>
      {wallet ? shortWalletAddress : children ?? '—'}
      {getTextContent(children) && wallet && (
        <Button onClick={handleCopy} variant='text' size='small'>
          {copied ? <CaretIcon /> : <ClipboardIcon />}
        </Button>
      )}
    </Box>
  );
};

export default DataCell;
